/*
 * Copyright (c) 2024. Tooling Team
 */

import React from "react";
import { MintHeader } from "../navigation/MintHeader";

export const LoggedOut = () => (
  <div>
    <MintHeader globalNav={false}></MintHeader>
    <div className="logged-out">
      <h1>Logged Out</h1>
    </div>
  </div>
);
